namespace SorAraBul.Administration {
    export interface RolePermissionListResponse extends Serenity.ListResponse<string> {
    }
}

